import { Component, inject, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { Router } from '@angular/router';
import { TherapyPlanListItemDto } from '@therapist/shared/models/therapy-plan/therapy-plan-list-item.dto';
import { TherapyPlanStatusTagComponent } from '@therapist/shared/components/therapy-plan-status-tag/therapy-plan-status-tag.component';

@Component({
  selector: 'sana-tp-client-therapy-plan-list',
  imports: [
    DatePipe,
    TableModule,
    TherapyPlanStatusTagComponent
  ],
  templateUrl: './client-therapy-plan-list.component.html',
  styleUrl: './client-therapy-plan-list.component.scss'
})
export class ClientTherapyPlanListComponent {

  readonly #router = inject(Router);

  @Input({ required: true }) therapyPlans!: TherapyPlanListItemDto[];
  @Input({ required: true }) clientId!: string;

  routeToTherapyPlanDetails(id: string) {
    this.#router.navigate([`/client/${this.clientId}/therapy-plan/${id}/details`]);
  }
}
